import posthogLib from 'posthog-js';
import { CartItem } from '@/types';
import { PRICES } from '@/utils/cart';

export type PassSource = 'event_ticket' | 'search_card' | 'gallery' | 'cart' | 'upsell';

/** Single entry point for every Event Pass analytics event. Never sends rider names or search text. */
export const trackEventPass = (name: string, props: Record<string, unknown> = {}) => {
  try {
    if (posthogLib.__loaded) posthogLib.capture(`event_pass_${name}`, props);
  } catch (e) {
    console.warn('event pass tracking failed', e);
  }
};

/** Fire for each pass in a cart (checkout start / purchase). */
export const trackPassesInCart = (name: 'checkout_started' | 'purchased', items: CartItem[], extra: Record<string, unknown> = {}) => {
  items.filter(i => i.type === 'event_pass').forEach(i => trackEventPass(name, {
    event_id: i.eventId, classes: i.passEntries?.length ?? 0, price: PRICES.EVENT_PASS, ...extra,
  }));
};
